export interface DefaultSectionProps {
  readonly showTopBorder?: boolean;
  readonly showBottomBorder?: boolean;
  readonly darkBackground?: boolean;
  readonly className?: string;
  readonly layout?: {
    mt: string | string[] | number | number[];
  };
}

// this is the default values for the DefaultSectionProps to spread in components stories to show as actions
export const DEFAULT_SECTIONS_PROPS_VALUES = {
  showTopBorder: false,
  showBottomBorder: false,
  darkBackground: false,
  className: '',
};

export const DEFAULT_SPACING = {
  pt: [40, 70],
  pb: [40, 70],
  px: [20],
};
